import React, {useState, useMemo} from 'react';
// Animation
import {motion} from 'framer-motion';
import styled from 'styled-components';
import imagesData from '../img/img-presta/imagesData'
import Footer from './Footer';

const Gallery = () => {
    const [search, setSearch] = useState('');
    const [selectedTag, setSelectedTag] = useState('');

    const allTags = useMemo(() => {
        const tags = imagesData.flatMap(img => img.tags || []);
        return Array.from(new Set(tags));
    }, [])

    const filteredImages = imagesData.filter(img =>
        (img.title.toLowerCase().includes(search.toLowerCase()) ||
        (img.tags && img.tags.some(tag => tag.toLowerCase().includes(search.toLowerCase())))) &&
        (selectedTag === '' || (img.tags && img.tags.includes(selectedTag))));

    return(
        <StyledGallery>
            <div className="search">
                <input
                    type="text"
                    placeholder='Rechercher un style...'
                    value = {search}
                    maxLength={10}
                    onChange={e => setSearch(e.target.value)}
                />
                <select name="filter" id="filter" value={selectedTag} onChange={e => setSelectedTag(e.target.value)}>
                    <option value="">Choisir un filtre</option>
                    {allTags.map(tag => 
                            <option value={tag} key={tag}>{tag}</option>
                        )}
                </select>
            </div>
            <div className="image-gallery">
                {filteredImages.map((img) => 
                <div className='gallery-img' key={img.id}>
                    <img src={img.src} alt={img.title} />
                </div>
                )
                }
            </div>
            <Footer className="footer"/>
        </StyledGallery>
    )
}

const StyledGallery = styled(motion.section)`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 20rem;

    .search{
        display: flex;
        justify-content: center;
        width: 100%;
    }
    input{
        width: 30%;
        padding: 1rem 1rem;
    }

    .image-gallery{
        min-height: 85vh;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
    }

    select{
        cursor: pointer;
        padding: .5rem 1rem;
        font-weight: 700;
        color: #6190e8;
    }

    .gallery-img{
        margin: 1rem 0rem;
        max-height: 30rem;
        width: 30%;
        img{
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 10px;
        }
    }

    @media (max-width: 768px){
        padding: 0rem 2rem;

        input{
            width: 50%;
        }
        
        select{
            padding: 0rem .5rem;
        }

        .gallery-img{
            width: 45%;
            img{
                border-radius: 0px;
            }
        }
    }
`

export default Gallery;